<template lang="pug">
    .telegraph-list
        .telegraph(v-for="item in mixinItems" :key="item.cls_id")
            p.content {{item.content}}

            p(v-if="item.stock_list && item.stock_list.length")
                el-tag.tag(v-for="stock in item.stock_list" :key="stock.code" size="mini" type="info")
                    router-link(:to='`/stock/${stock.code}`') {{stock.name}}
            p.date {{new Date(item.timestamp * 1000).toLocaleString()}}
        el-pagination.tc(layout="prev, pager, next" :current-page="mixinPage" :total="mixinCount" @current-change="pageChange" background)
</template>

<script>
import listMixin from './list-mixin.vue';
import intervalMixin from './interval-mixin.vue';

export default {
    name: 'Telegraph',
    mixins: [listMixin, intervalMixin],
    data() {
        return {
            // mixinSize: 30,
            mixinUrl: 'v2/finance/cls-telegraph',
            mixinOnlyTradingTime: false,
        };
    },
    methods: {
        handleClick({ name }) {},
        mixinIntervalMethods() {
            this.mixinGetList();
        },
        pageChange(n) {
            // 重写 mixin 方法
            if (n != 1) {
                this.mixinUpdated = null;
            }
            if (n == 1) {
                this.mixinUpdated = new Date().valueOf();
                if (!this.mixinIntervalRunning) {
                    this.mixinInterval();
                }
            }

            this.mixinPage = n;
            this.mixinGetList();
        },
    },
};
</script>

<style lang="stylus" scoped>
.green
    color green
.red
    color red
.content
    font-size 12px
.date
    color #666
    font-size 12px

.tag
    margin-right 10px
.telegraph
    border-left 1px solid #246cf9
    padding-left 10px
    margin-bottom 15px
    p
        margin-bottom 10px
</style>
